import { Button, Combobox } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import FieldSelect from 'components/shared/form/FieldSelect';
import { useCreateMeetingDrawerModal } from 'stores/global/CreateMeetingDrawerModal';
import { CreateMeetingDrawerModalMode } from 'types/CreateMeetingDrawerModalMode';

const SubAgentSelect: React.FC = () => {
  const createMeetingDrawerModal = useCreateMeetingDrawerModal();
  const { createLoadingStage, isStaticMode, subAgent } = createMeetingDrawerModal;

  const onCreateSubAgent = React.useCallback(() => {
    createMeetingDrawerModal.createSubAgentStore.reset();
    isStaticMode.change(CreateMeetingDrawerModalMode.openCreateSubAgent);
  }, [isStaticMode, createMeetingDrawerModal]);

  const createSubAgentOptionsFooter = React.useCallback(
    (beforeCreateSubAgent: () => void) => (
      <Combobox.Footer>
        <Button
          size="md"
          // eslint-disable-next-line
          onClick={() => {
            beforeCreateSubAgent();
            onCreateSubAgent();
          }}
          fullWidth
        >
          Создать субагента
        </Button>
      </Combobox.Footer>
    ),
    [onCreateSubAgent],
  );

  if (!subAgent.shown) {
    return null;
  }

  return (
    <FieldSelect
      fw="600"
      label="Субагент"
      placeholder="Выберите субагента"
      store={subAgent}
      disabled={createLoadingStage.isLoading}
      optionsFooter={createSubAgentOptionsFooter}
    />
  );
};

export default observer(SubAgentSelect);
